import { BILLING_ADDRESS_REGEX } from '../constants/regex';
import { getHyphenatedPhoneNumber } from './general';
import { CreditCardBrands } from '../constants/credit-card';
export const getTextFieldStatus = (error) => error ? 'error' : undefined;
const isHDCard = (cardBrand) => cardBrand === CreditCardBrands.HDCOM ||
    cardBrand === CreditCardBrands.HDCON ||
    cardBrand === CreditCardBrands.PROX;
export const getAddressFormValues = (address) => {
    const cityState = address ? `${address.city}, ${address.state}` : '';
    return {
        isDefault: (address === null || address === void 0 ? void 0 : address.isDefault) || false,
        companyName: (address === null || address === void 0 ? void 0 : address.companyName) || '',
        primaryPhone: getHyphenatedPhoneNumber((address === null || address === void 0 ? void 0 : address.primaryPhone) || ''),
        alternatePhone: getHyphenatedPhoneNumber((address === null || address === void 0 ? void 0 : address.alternatePhone) || ''),
        firstName: (address === null || address === void 0 ? void 0 : address.firstName) || '',
        lastName: (address === null || address === void 0 ? void 0 : address.lastName) || '',
        nickName: (address === null || address === void 0 ? void 0 : address.nickName) || '',
        zipCode: (address === null || address === void 0 ? void 0 : address.zipCode) || '',
        addressLine1: (address === null || address === void 0 ? void 0 : address.addressLine1) || '',
        addressLine2: (address === null || address === void 0 ? void 0 : address.addressLine2) || '',
        cityState,
    };
};
export const getCreditCardFormValues = (payment) => {
    const cityState = (payment === null || payment === void 0 ? void 0 : payment.city) ? `${payment.city}, ${payment.state}` : '';
    const buyerId = (payment === null || payment === void 0 ? void 0 : payment.buyerId) || '';
    const cardNumberLast4 = (payment === null || payment === void 0 ? void 0 : payment.cardNumberLast4) || '';
    const cardNumber = '****' + cardNumberLast4 + ' ' + buyerId;
    return {
        isDefault: (payment === null || payment === void 0 ? void 0 : payment.isDefault) || false,
        cardNickName: (payment === null || payment === void 0 ? void 0 : payment.cardNickName) || '',
        cardNumber,
        cardHolderName: (payment === null || payment === void 0 ? void 0 : payment.cardHolderName) || '',
        cardExpiryMonth: (payment === null || payment === void 0 ? void 0 : payment.cardExpiryMonth) || '',
        cardExpiryYear: (payment === null || payment === void 0 ? void 0 : payment.cardExpiryYear) || '',
        addressLine1: (payment === null || payment === void 0 ? void 0 : payment.addressLine1) || '',
        addressLine2: (payment === null || payment === void 0 ? void 0 : payment.addressLine2) || '',
        zipCode: (payment === null || payment === void 0 ? void 0 : payment.zipCode) || '',
        cityState,
        isHDCard: isHDCard(payment === null || payment === void 0 ? void 0 : payment.cardBrand),
        primaryPhone: (payment === null || payment === void 0 ? void 0 : payment.primaryPhone) || { number: '' },
        billingAddressID: Number(payment === null || payment === void 0 ? void 0 : payment.addressId) || null,
    };
};
export const isAllowedCharacter = (key, field) => {
    if (field === 'addressLine1' || field === 'addressLine2')
        return BILLING_ADDRESS_REGEX.test(key);
    return false;
};
